"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridEmptyBody = void 0;
const react_1 = __importDefault(require("react"));
const GridEmptyBody_styles_1 = require("./GridEmptyBody.styles");
exports.GridEmptyBody = react_1.default.memo(function GridEmptyBody({ text = 'No data' }) {
    return (react_1.default.createElement(GridEmptyBody_styles_1.StyledGridEmptyBody, { "data-selector-id": "grid-core-empty-body", className: "vm-GridEmptyBody" }, text));
});
//# sourceMappingURL=GridEmptyBody.js.map